import { lightFormat } from 'date-fns';
import utilSvc from '../../../core/utilSvc';
import validSvc from '../../../core/validSvc';
import { ValidOption } from '../../../core/components/validation/types';
import { validPropTextVM } from '../../../core/components/validation/ValidInputText';
import { validPropDroplistTextVM } from '../../../core/components/validation/ValidInputDroplistText';
import { validPropRadioTextVM } from '../../../core/components/validation/ValidInputRadioText';
import { EditState, AdminPayorModel, PayorEditPageState } from './payor_edit_types'; // TableState, PayorItem, StoreState, MedType } from "./types";

// PAGE
export function pageStateVM(): PayorEditPageState {
    return {
        init: true,
        title: '',
        canEdit: false,
        mode: '',
        id: '',
    };
}

// EDIT FORM
export function editStateVM(): EditState {
    return {
        init: true,
        waiting: false,
    };
}
export function modelVM(data?): AdminPayorModel {
    data = data || {};

    const stateOptions = utilSvc.loc.stateNames() as ValidOption[];
    stateOptions.unshift({ lbl: 'Not Specified', val: '' });

    return {
        Id: !!data.Id ? data.Id : '',
        Status: validPropTextVM('Status', 'Status', data.ObjectState),
        MedType: validPropRadioTextVM('MedType', 'Type', data.MedType, '', [
            { lbl: 'MANAGED', val: 'MM' },
            { lbl: 'MEDICAID', val: 'M' },
        ]),
        State: validPropDroplistTextVM('State', 'State', data.State, '', stateOptions),
        BIN: validPropTextVM('BIN', 'BIN', data.BIN),
        PCN: validPropTextVM('PCN', 'PCN', data.PCN),
        Name: validPropTextVM('Name', 'Payor Description', data.Name),
        GroupNumber: validPropTextVM('GroupNumber', 'Group Number', data.GroupNumber),
        CreatedBy: !!data.CreatedBy ? data.CreatedBy : '',
        CreatedDate: validSvc.isDate(data.CreatedDate) ? lightFormat(data.CreatedDate, utilSvc.dt.fmtMdyyyy) : '',
        ModifiedBy: !!data.ModifiedBy ? data.ModifiedBy : '',
        ModifiedDate: validSvc.isDate(data.ModifiedDate) ? lightFormat(data.ModifiedDate, utilSvc.dt.fmtMdyyyy) : '',
    };
}
